import { Injectable } from '@angular/core';
import { UserCommerce } from 'commerce/models';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private user?: UserCommerce = undefined;

    getUser() {
        return this.user;
    }

    setUser(user: UserCommerce) {
        this.user = user;
    }
}
